// extracted by mini-css-extract-plugin
export default {"holo":"FilterGroup_holo_v4Ryy"};